import { render, staticRenderFns } from "./EditVonBisALT.vue?vue&type=template&id=50674d46&scoped=true"
import script from "./EditVonBisALT.vue?vue&type=script&lang=ts"
export * from "./EditVonBisALT.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50674d46",
  null
  
)

export default component.exports